import { afterNextRender, signal, type Signal } from '@angular/core';

export const isBrowser = () => typeof window !== 'undefined';
export const isServer = () => !isBrowser();

/** Stays false during SSR and the hydration pass, then true on the client. */
export function createClientReadySignal(): Signal<boolean> {
  const ready = signal(false);
  afterNextRender(() => {
    ready.set(true);
  });
  return ready;
}
